module.exports = __webpack_public_path__ + "img/nav-45.b20725ef.png";